import React from "react";
import { useTranslation } from "react-i18next";
import "./LanguageSelector.css";

export default function LanguageSelector() {
  const { i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="language-container">
      <button
        type="button"
        className={`lang-btn ${i18n.language === "es" ? "active" : ""}`}
        onClick={() => changeLanguage("es")}
        title="Español"
      >
        ES
      </button>
      
      <span className="lang-separator">|</span>

      <button
        type="button"
        className={`lang-btn ${i18n.language === "en" ? "active" : ""}`}
        onClick={() => changeLanguage("en")}
        title="English"
      >
        EN
      </button>
    </div>
  );
}
